import { apiClient } from "./ApiClient";

// Login
const loginUser = async (email, password) => {
  const { data } = await apiClient.post("/auth/login", { email, password });
  return data;
};

// Verify 2FA dla APP
const verifyLoginApp = async (email, code, redirectUrl) => {
  const { data } = await apiClient.post("/auth/verify-login-app", {
    email,
    code,
    redirect_url: redirectUrl,
  });
  return data;
};

// Verify 2FA dla EMAIL
const verifyLoginEmail = async (email, code, redirectUrl) => {
  const { data } = await apiClient.post("/auth/verify-login-email", {
    email,
    code,
    redirect_url: redirectUrl,
  });
  return data;
};

// Registration
const registerUser = async (email, password, username, affiliateCode = null, newsletter = false) => {
  const payload = {
    email,
    password,
    username,
    user_service: true,
    newsletter,
  };
  if (affiliateCode) {
    payload.affiliate_user_code = affiliateCode;
  }
  const { data } = await apiClient.post("/auth/register", payload);
  return data;
};

// AuthenticationService.js
const firebaseLogin = async ({
  token,
  user_service = true,
  affiliate = null,
  newsletter = false,
  google = false, // Default true for Firebase/Google
} = {}) => {
  // POST body ONLY has token
  const payload = { token };

  // Build query string for bools/optional params
  const params = new URLSearchParams();
  params.append("user_service", user_service);
  if (affiliate) params.append("affiliate_code", affiliate);
  if (newsletter !== false && newsletter !== undefined) params.append("newsletter", newsletter);
  params.append("google", google);

  const url = `/auth/firebase/login?${params}`;
  const { data } = await apiClient.post(url, payload);
  return data;
};

const appleLogin = async (idToken, userService = true, affiliate = null, newsletter = false) => {
  const tokenString = String(idToken);
  if (!tokenString || tokenString.length < 50) {
    throw new Error("Invalid Apple ID token");
  }
  const params = new URLSearchParams({
    id_token: tokenString,
    user_service: userService,
    ...(affiliate && { affiliate }),
    ...(newsletter !== false && { newsletter }),
  });
  const { data } = await apiClient.get(`/auth/apple/login?${params}`);
  return data;
};

const googleOAuthLogin = async (code, userService = true, affiliate = null, newsletter = false) => {
  const params = new URLSearchParams({
    code,
    user_service: userService,
    ...(affiliate && { affiliate }),
    ...(newsletter !== false && { newsletter }),
  });
  const { data } = await apiClient.get(`/auth/google/login?${params}`);
  return data;
};

// Send reset code
const sendResetCode = async (email) => {
  const { data } = await apiClient.post(`/auth/send-password-reset-code?email=${encodeURIComponent(email)}`);
  return data;
};

// Reset password
const resetPassword = async (email, code, newPassword) => {
  const { data } = await apiClient.post("/auth/update-password", {
    email,
    code,
    new_password: newPassword,
  });
  return data;
};

// Send Verification Code
const sendVerificationCode = async (email, language = "en") => {
  const params = new URLSearchParams({
    email,
    language,
  });

  const { data } = await apiClient.post(`/auth/send-email-verification-code?${params.toString()}`);
  return data;
};

// Verify Email
const verifyEmailCode = async (email, code) => {
  const { data } = await apiClient.post("/auth/verify-email-code", {
    email,
    code,
  });
  return data;
};

const requestTwoFactorRecovery = async (email) => {
  const { data } = await apiClient.post(`/auth/app/recovery/request?user_id=${encodeURIComponent(email)}`);

  return data;
};

// Check token
const checkToken = async () => {
  const { data } = await apiClient.get("/auth/check-token");
  return data;
};

export default {
  loginUser,
  verifyLoginApp,
  verifyLoginEmail,
  requestTwoFactorRecovery,
  registerUser,
  sendResetCode,
  resetPassword,
  checkToken,
  sendVerificationCode,
  verifyEmailCode,
  firebaseLogin,
  appleLogin,
  googleOAuthLogin,
};
